"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const clone = require("clone");
const deepmerge = require("deepmerge");
function BaseFactory() {
    var _a;
    /**
     * Convenience class for defining factories in our test suite.  The extended
     * class must define the defaultAttributes and traitMap.
     *
     * @example
     *
     *   class MyFactory extends BaseFactory<Object>() {
     *     static readonly constructorType: typeof Object = Object;
     *     static readonly defaultAttributtes = { foo: 'bar' };
     *     static readonly traitMap = {
     *       withBaz: (attributes, traitArg) => { attributes.baz = traitArg }
     *       default: (attributes, traitArg) => {}
     *     }
     *   }
     *
     * const instance = MyFactory.build({ qux: 'qux' }, [{withBaz: 'baz'}])
     * //=> { foo: 'bar', baz: 'baz', qux: 'qux' }
     */
    return _a = class {
            static build(additionalAttributes = {}, traits = []) {
                return new this().build(additionalAttributes, traits);
            }
            build(additionalAttributes, traits = {}) {
                const { constructorType: ConstructorType } = this.constructor;
                const defaultAttributes = clone(this.constructor.defaultAttributes);
                const overwriteMerge = (destination, source) => source;
                const attributes = deepmerge(defaultAttributes, additionalAttributes, { arrayMerge: overwriteMerge });
                return Object.assign(new ConstructorType(), this.applyTraits(attributes, traits));
            }
            applyTraits(attributes, traits) {
                const { traitMap } = this.constructor;
                return Object.entries(traits).reduce((newAttributes, [key, value]) => {
                    const applier = traitMap[key] || traitMap.default;
                    return applier(newAttributes, value);
                }, attributes);
            }
        },
        /**
         * @property {constructor} constructorType - The constructor type to be used
         *                                           when instantiating the <T> class.
         */
        _a.constructorType = Object,
        /**
         * @property {Object} traitMap - An object where the values are a function
         *                               that applies the trait to the attributes.
         */
        _a.traitMap = {},
        /*
         * The default attributes to use when building the instance of the class <T>.
         * Must be defined in the extended class.
         *
         * @property {string} defaultAttributes - The default attributes to use.
         */
        _a.defaultAttributes = {},
        _a;
}
exports.BaseFactory = BaseFactory;
//# sourceMappingURL=base-factory.js.map